export const environment = {
  production: false,
  apiUrl: 'https://userverwaltung-api.qa.cpit.app',
  keycloakConfig: {
    url: 'https://auth.qa.cpit.app/',
    realm: 'cpit-qa',
    clientId: 'cpit-userverwaltung-frontend',
  },
  stage: 'QA',
};
